/* eslint-disable */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { Select } from '@ali/aps';
const { Option } = Select;
@inject('dashboardStore')
@observer
class Card extends Component {
  constructor(props) {
    super(props);
    this.product = props.product;
    this.showText = '';
    this.exts = [];
    this.readKeys = [];
    if (props.exts && props.exts.keys) {
      this.exts = props.exts.keys.value.split('|');
    }
    if (props.exts && props.exts.readKeys) {
      this.readKeys = props.exts.readKeys.value.split('|');
    }
    this.state = {
      defaultValue: null,  //通过product获取的默认选项
      selectArr: null,     //通过exts匹配过后的列表选项
      initPrice: null,     //没有询价前得到的默认价格
      discountPrice: null, //没有询价前得到的默认折扣价格
      loading: false,
      isServer: true
    };
  }

  async componentDidMount() {
    await this.props.product.setValueWithConstranit();
    await this.queryPrice();
  }
  popUpConfig = async () => {
    if (this.props.dashboardStore.isLogin) {
      await this.props.product.popUpConfig()
      await this.queryPrice();
      //this.chooseCard(this.props.productCode)
      await this.props.dashboardStore.chooseCardPopUpConfig(this.props.status)
      this.props.dashboardStore.addProduct(this.props.productCode);
      this.props.dashboardStore.addCart(this.props.status)
      this.props.dashboardStore.changeTotalPrice(this.props.status, this.state.initPrice);
    } else {
      this.props.dashboardStore.handleNotLogin()
    }
  }
  format = (value) => {
    let valueArr = []
    valueArr = value.split(":")
    let showText = ''
    if (valueArr[1] == "Month") {
      showText = "月"
    } else {
      showText = "年"
    }
    showText = valueArr[0] + showText + ''
    return showText
  }
  //处理售罄的情况price为undefined的情况
  removeUndefined=(price)=>{
    if(price===undefined){
      return 0
    }else{
      return price
    }
  }

  queryPrice = async () => {
    this.props.dashboardStore.changeLoading(true)
    this.setState({
      loading: true
    })
    const priceObj = await this.product.getAllPrice();
    let defaultValue = await this.product.getValue()
    //console.log(priceObj, 'priceObj', defaultValue)

    if (defaultValue.ord_time) {
      this.showText = this.format(defaultValue.ord_time)
    }
    //console.log(this.showText, "showText")
    this.setState({
      initPrice: this.removeUndefined(priceObj.price),
      isServer: priceObj.isServer,
      discountPrice:this.removeUndefined(priceObj.discountPrice)
    });
    this.props.dashboardStore.changeTotalPrice(this.props.status,this.removeUndefined(priceObj.price)); //改变价格
    this.props.dashboardStore.changeLoading(false)
    this.setState({
      loading: false
    })
  }

  async onChange(key, event) {
    this.setState({
      loading: true
    })
    await this.props.product.setValueWithConstranit({
      [key]: event.target.value
    });
    this.queryPrice();
  }

  async chooseCard(productCode) {
    if (!this.props.dashboardStore.isLogin) {
      this.props.dashboardStore.handleNotLogin()
    } else {
      await this.props.dashboardStore.chooseCard(this.props.status)
      if (this.props.dashboardStore.cardStatus[this.props.status]) {
        this.props.dashboardStore.addProduct(productCode);
        this.props.dashboardStore.addCart(this.props.status)
        this.props.dashboardStore.changeTotalPrice(this.props.status, this.state.initPrice); //选中的时候把价格改为当时的价格
      } else {
        this.props.dashboardStore.removeProduct(productCode,this.props.status)         //移除这个商品
        this.props.dashboardStore.changeTotalPrice(this.props.status, 0);  //把价格改为0
        this.props.dashboardStore.removeCart(this.props.status)            //把这个商品从购物车移除      
      }
    }
  }


  render() {
    //console.log(this.sellOut,"this.sellOut")
    const productCode = this.props.productCode;
    const { name, description, product } = this.props.goods
    const nowConfig = product.getValue();
    //console.log(nowConfig,"nowConfig")
    // 选项
    const nowOptions = this.props.product.getOptions();
    let selectArr = [];
    this.exts.map((item) => {
      let abc = nowOptions.find((element) => (element.label == item));
      selectArr.push(abc);
    });
    // end 选项
    const initPrice = (Number(this.state.initPrice)).toFixed(2);
    const discountPrice = (Number(this.state.discountPrice)).toFixed(2);
    const { textArrLength } = this.props;
    const { cardStatus } = this.props.dashboardStore;
    const status = this.props.status;
    let cardWidth = 1120 / textArrLength - 8 + "px";
    cardWidth = { width: cardWidth }
    let sellOut = this.props.product.hasSetValue && !this.state.isServer && !this.state.loading
    const readKeys = this.readKeys
    //console.log(this.readKeys,"this.readKeys",selectArr,"selectArr");
    
    return (
      <div className={`${cardStatus[status] ? "card-inner-active" : 'card-inner'}`} style={cardWidth}>
        <div className="card-inner-top" onClick={() => this.chooseCard(productCode)}>
          {cardStatus[status] ? <div className="img-wrap">
            <img className="arrow-img" src="https://img.alicdn.com/tfs/TB16OGsAFzqK1RjSZFoXXbfcXXa-28-20.png" alt="" />
          </div> : null}
          <div className="hover-block"></div>
          <p className="card-inner-top-title">
            {name ? name : ""}
          </p>
          <p className="card-inner-top-desc">
            {description ? description : ""}
          </p>
        </div>
        <div className="card-inner-middle">
          {selectArr ?
            selectArr.map((item, index) => {
              if(readKeys.indexOf(item.label)!=-1){
                //console.log(item,"item");
                let abc = item.value.find((element) => (element.value == nowConfig[item.key]));
                return(
                  <div className="card-inner-middle-select" key={index}>
                    <span className="card-inner-middle-title">{item.label}</span>
                    <span className="card-inner-middle-desc">{abc.text}</span>
                  </div>
                )
              }else{
                return (
                  <div className="card-inner-middle-select" key={index}>
                    <span className="card-inner-middle-title">{item.label}</span>
                    <Select
                      value={nowConfig[item.key]}
                      onChange={this.onChange.bind(this, item.key)}
                      size="small" style={{ flex: '1', width: '100%' }}>
                      {
                        item.value.map((item) => {
                          return <Option value={item.value} key={item.value}>{item.text}</Option>;
                        })
                      }
                    </Select>
                  </div>
                );
              }
            })
            : null}
          {sellOut ?
            <div>
              <p className="price"><span>已售罄</span></p>
            </div> :
            <div>
              <p className="price">{this.state.loading ? <span>计算中...</span> : <span>{initPrice}元/{this.showText}</span>}</p>
              <p className="discount">{this.state.loading ? <span>计算中...</span> : <span>省{discountPrice}元/{this.showText}</span>}</p>
            </div>
          }

        </div>
        <div className="card-inner-bottom" onClick={this.popUpConfig} data-spm-click={`gostr=/aliyun;locaid=${this.props.status}`}>
          选择详细配置
        </div>
      </div>
    );
  }
}

export default Card;


// WEBPACK FOOTER //
// ./src/scripts/components/Card/index.js